import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonalVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"personal_video"}/>
}
